const formatPhoneNumber = (newValue) => {
const digitsOnly = newValue.replace(/\D/g, '');
const cleaned = digitsOnly.slice(-10);
const formattedPhoneNumber = `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6, 10)}`;

return formattedPhoneNumber;
};

const formatDate = (newValue) => {
  const parsedDate = new Date(newValue);
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate() + 1).padStart(2, '0');
  const formattedEffDate = `${month}/${day}/${year}`;

  return formattedEffDate;
};

const formatDateTime = (iso) => new Date(iso).toLocaleString(undefined, {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});


const handleDateChange = (event, handleInputChange) => {
  let value = event.target.value; // YYYY-MM-DD format from date input

  if (value) {
    let [year, month, day] = value.split('-');

    // Ensure the year is only 4 digits
    if (year.length > 4) {
      year = year.slice(0, 4);
      value = `${year}-${month}-${day}`;
      event.target.value = value; 
    }
  }
  handleInputChange(event);
};

export { formatPhoneNumber, formatDate, formatDateTime, handleDateChange };
